import type { LevelDefinition } from "@/domain";

import type { LetterSoundPayload } from "./types";

const instruction = "小耳朵准备好。听听这个字母音，再找到对应的小写字母。";
const promptAudio = "/audio/english/instructions/letter-sound.ogg";

export const letterSoundLevels: LevelDefinition<LetterSoundPayload>[] = [
  {
    id: "english-letter-sound-1",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 1,
    objectives: ["听辨一个清晰的英语字母音"],
    title: "听音找字母 1",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/m.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/m.ogg",
      exampleWord: "moon",
      choiceTokens: ["m", "s"],
      answerTokens: ["m"]
    }
  },
  {
    id: "english-letter-sound-2",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 2,
    objectives: ["在两个字母中辨认目标字母音"],
    title: "听音找字母 2",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/s.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/s.ogg",
      exampleWord: "sun",
      choiceTokens: ["s", "m"],
      answerTokens: ["s"]
    }
  },
  {
    id: "english-letter-sound-3",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 3,
    objectives: ["在三个字母中辨认目标字母音"],
    title: "听音找字母 3",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/f.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/f.ogg",
      exampleWord: "fish",
      choiceTokens: ["f", "s", "m"],
      answerTokens: ["f"]
    }
  },
  {
    id: "english-letter-sound-4",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 4,
    objectives: ["区分发音接近的英语字母音"],
    title: "听音找字母 4",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/n.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/n.ogg",
      exampleWord: "nest",
      choiceTokens: ["n", "m", "l"],
      answerTokens: ["n"]
    }
  },
  {
    id: "english-letter-sound-5",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 5,
    objectives: ["在四个字母中辨认目标字母音"],
    title: "听音找字母 5",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/l.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/l.ogg",
      exampleWord: "leaf",
      choiceTokens: ["l", "r", "n", "m"],
      answerTokens: ["l"]
    }
  },
  {
    id: "english-letter-sound-6",
    domain: "english",
    activityType: "letter-sound",
    difficulty: 6,
    objectives: ["稳定区分四个英语字母音"],
    title: "听音找字母 6",
    instruction,
    promptAudio,
    assets: ["/audio/english/letter-sounds/r.ogg"],
    payload: {
      kind: "letter-sound",
      soundAudio: "/audio/english/letter-sounds/r.ogg",
      exampleWord: "rabbit",
      choiceTokens: ["r", "l", "n", "f"],
      answerTokens: ["r"]
    }
  }
];
